import { Controller } from "@hotwired/stimulus"

// Moves specialist rows on the organization booking form. Save writes position from that order.
export default class extends Controller {
  static targets = ["row"]

  up(event) {
    this.move(event, -1)
  }

  down(event) {
    this.move(event, 1)
  }

  move(event, direction) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-bookable-order-target='row']")
    if (!row) return

    const sibling = direction < 0 ? row.previousElementSibling : row.nextElementSibling
    if (!sibling) return

    if (direction < 0) {
      row.parentElement.insertBefore(row, sibling)
    } else {
      row.parentElement.insertBefore(sibling, row)
    }
    this.refresh()
  }

  refresh() {
    const rows = this.rowTargets
    rows.forEach((row, index) => {
      const up = row.querySelector("[data-bookable-order-direction='up']")
      const down = row.querySelector("[data-bookable-order-direction='down']")
      if (up) up.disabled = index === 0
      if (down) down.disabled = index === rows.length - 1
    })
  }
}
